import { PUBLIC_GLOBALADMIN, PUBLIC_CUSTOMERADMIN, PUBLIC_PROJECTADMIN, PUBLIC_APPUSER, PUBLIC_PROJECTTRANSLATOR, PUBLIC_APPTRANSLATOR, PUBLIC_ADMINTRANSLATOR } from '$env/static/public';

// @ts-nocheck
export const globalAdminRole = PUBLIC_GLOBALADMIN;

export const customerAdminRole = PUBLIC_CUSTOMERADMIN;

export const projectAdminRole = PUBLIC_PROJECTADMIN;

export const appUserRole = PUBLIC_APPUSER;

export const projectTranslatorRole = PUBLIC_PROJECTTRANSLATOR;

export const adminRoles = [globalAdminRole, customerAdminRole, projectAdminRole, projectTranslatorRole];

// Specific policies that can be manually given to individual translators that will give them right to translate the app, admin system and similar.
export const appTranslatorPolicy = PUBLIC_APPTRANSLATOR;

export const adminTranslatorPolicy = PUBLIC_ADMINTRANSLATOR;


